



















import { Component, Vue } from 'vue-property-decorator'
import { AuthService as _authService } from '@/services/auth.service'
import { UserService as _userService } from '@/services/user.service'
import router from '@/router'
import LoginCard from '@/components/LoginCard.vue'
import { UserDto } from '@/models/dtos/userDto'
import { LoginDto } from '@/models/dtos/loginDto'
import { SelectDto } from '@/models/dtos/selectDto'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import { EUserStatus } from '@/models/dtos/enums/eUserStatus'

@Component({
  components: { LoginCard }
})
export default class Login extends Vue {
    // Data
    users: UserDto[] = [];
    employeeTypes: EmployeeTypeDto[] = [];
    employeeTypeSelect: SelectDto[] = [];
    selectedEmployeeType = null;
    searchPhrase = '';

    // Methods
    private async signin(login: LoginDto): Promise<void> {
      const isLogged = await _authService.login(login)

      if (isLogged) {
        router.push('/')
      }
    }

    initUserTypesSelect(): void {
      this.employeeTypeSelect.push({ text: 'Dowolny', value: null, disabled: false })

      for (const userType of this.employeeTypes) {
        this.employeeTypeSelect.push({
          text: userType.name,
          value: userType.id,
          disabled: false
        })
      }
    }

    // Getters - TODO
    get filteredUsers() {
      let results = [...this.users]

      if (this.searchPhrase.length > 1) {
        const phrase = this.searchPhrase.toLowerCase()

        results = results.filter((user: UserDto) =>
          user.firstName?.toLowerCase()?.includes(phrase) ||
          user.lastName?.toLowerCase()?.includes(phrase) ||
          user.userName?.toLowerCase()?.includes(phrase))
      }

      if (this.selectedEmployeeType) {
        results = results.filter((user: UserDto) =>
          user.employeeType.id === this.selectedEmployeeType)
      }

      return results
    }

    // Lifecycle
    async created() {
      this.employeeTypes = await _userService.GetEmployeeTypes()
      this.users = (await _userService.getUsers()).filter(u => u.status === EUserStatus.Active)

      this.initUserTypesSelect()
    }
}
